import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const FeatherIcon = createIcon({
  displayName: 'FeatherIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16,8l-13,13"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.874,10.115l5.679,-5.668c1.934,-1.93 5.065,-1.928 6.997,0.003v0c1.934,1.934 1.933,5.071 -0.003,7.003l-5.675,5.664c-0.562,0.561 -1.325,0.877 -2.119,0.877h-5.759v-5.756c0,-0.797 0.317,-1.561 0.88,-2.123Z"
        ></path>
      </g>
    </>
  ),
})

const Feather: FC<IconProps> = (props) => {
  return <CustomIcon as={FeatherIcon} {...props} />
}

export default memo(Feather)
